import React from 'react';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import RightSidebar from 'Views/Page/Content/RightSidebar';
import { RightSidebarProvider } from 'Views/Page/Content/RightSidebar/RightSidebarContext';
import PropTypes from 'prop-types';
import MainContent from './MainContent';
import SidebarPicker from './SideBarPicker';

const useStyles = buildUseStyles('GenericTableTemplate', () => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'stretch',
    flex: 1,
  },
}));

const GenericTableTemplate = ({ mainContentSubHeader, itemListMetaOverride }) => {
  const classes = useStyles();

  return (
    <RightSidebarProvider>
      <Box className={classes.root}>
        <SidebarPicker />
        <MainContent mainContentSubHeader={mainContentSubHeader} itemListMetaOverride={itemListMetaOverride} />
        <RightSidebar />
      </Box>
    </RightSidebarProvider>
  );
};

GenericTableTemplate.propTypes = {
  mainContentSubHeader: PropTypes.node,
  itemListMetaOverride: PropTypes.object,
};

GenericTableTemplate.defaultProps = {
  mainContentSubHeader: null,
  itemListMetaOverride: null,
};

export default GenericTableTemplate;
